//imports
import {
    EVENT_CREATE_EDIT_OPEN_MODAL,
    EVENT_CREATE_REQUEST,
    EVENT_CREATE_RESULT,
    EVENT_EDIT_REQUEST,
    EVENT_EDIT_RESULT,
    EVENT_GET_REQUEST,
    EVENT_GET_RESULT,
    EVENT_GET_UNIT_TYPES_REQUEST,
    EVENT_GET_UNIT_TYPES_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    create: null,
    update: null,
    event: null,
    current: null,
    unitTypes: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case EVENT_GET_REQUEST:
            return { ...state, loading: true }

        case EVENT_GET_RESULT:
            return { ...state, loading: false, event: action.payload }

        case EVENT_CREATE_EDIT_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, current: action.payload.event }

        case EVENT_CREATE_REQUEST:
            return { ...state, loading: true }

        case EVENT_CREATE_RESULT:
            return { ...state, loading: false, create: action.payload }

        case EVENT_EDIT_REQUEST:
            return { ...state, loading: true }

        case EVENT_EDIT_RESULT:
            return { ...state, loading: false, update: action.payload }

        case EVENT_GET_UNIT_TYPES_REQUEST:
            return { ...state, loading: true }

        case EVENT_GET_UNIT_TYPES_RESULT:
            return { ...state, loading: false, unitTypes: action.payload }

        case CLEAR_REDUX:
            return ["", "EVENT_CREATE_EDIT"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};